import { call, put, takeEvery } from 'redux-saga/effects';
import { dashboardApi } from '../../services/dashboardApi';
import {
  fetchDashboardStatsStart,
  fetchDashboardStatsSuccess,
  fetchDashboardStatsFailure,
} from '../reducers/dashboardSlice';

// Fetch dashboard stats saga
function* fetchDashboardStatsApi(): Generator<any, void, any> {
  try {
    const response = yield call(dashboardApi.getStats);
    yield put(fetchDashboardStatsSuccess(response));
  } catch (error: any) {
    yield put(fetchDashboardStatsFailure(error.message || 'Failed to fetch dashboard stats'));
  }
}

// Root dashboard saga
export default function* dashboardSaga(): Generator<any, void, any> {
  yield takeEvery(fetchDashboardStatsStart.type, fetchDashboardStatsApi);
} 